<template>
  <div id="container" class="cart_st">
    <!-- 약관 동의 START-->
    <div class="section full">
      <div class="inner">
        <div class="btn_wrap" data-detail="shortcuts">
          <router-link :to="{ name: 'orders' }" class="box_btn line">
            <span class="c_icon ico_shortcuts_arrow"></span>
            <span class="an_t">{{ $t('views.member.closeaccount.5666') }}</span>
          </router-link>
        </div>
        <div class="box_wrap" data-detail="se_detail">
          <div class="box">
            <div class="box_title">
              <h2>{{ $t('views.member.closeaccount.406') }}</h2>

              <h2 class="done_tit">
                캠퍼스북 탈퇴 전 확인하세요
              </h2>
              <p class="guide_txt">
                탈퇴시 이용중인 모든 e-Book데이터는 삭제됩니다. 삭제된 정보는
                다시 복구할 수 없습니다.
              </p>
            </div>

            <ul class="info_text_wrap">
              <li class="tit">{{ $t('views.member.closeaccount.4800') }}</li>
              <li>
                고객님의 회원정보는 전자상거래 상에서의 소비자보호 법률에 의거한
                캠퍼스북의 개인정보보호정책에 따라 관리됩니다.
              </li>
              <li>
                진행중인 구매 내역이 있는 경우는 회원탈퇴가 불가능하오니, 구매
                종료 후 회원 탈퇴 하실 수 있습니다.
              </li>
              <li>
                구매 및 대여하신 eBook 콘텐츠는 로그인을 통한 회원식별이
                필요하므로 회원탈퇴 시 이용이 불가능합니다.
              </li>
              <li>
                회원탈퇴 시 회원정보는 자동으로 삭제되며, 탈퇴 후 한 달 동안은
                재가입이 불가능합니다. <br />
                또한 재가입 시에 기존 사용ID로는 이용하실 수 없습니다.
              </li>
            </ul>

            <p class="add_tit">{{ $t('views.member.closeaccount.5271') }}</p>

            <div class="text_wrap">
              <ul class="join_check">
                <li>
                  <div class="text_label">
                    <label>
                      <input
                        v-model="reasonsForDelete"
                        value="10"
                        type="checkbox"
                        class="check_agree"
                      />
                      <em></em>
                      <span>사용빈도 낮음</span>
                    </label>
                  </div>
                </li>
                <li>
                  <div class="text_label">
                    <label>
                      <input
                        v-model="reasonsForDelete"
                        type="checkbox"
                        value="11"
                        class="check_agree"
                      />
                      <em></em>
                      <span>컨텐츠 다양성 불만</span>
                    </label>
                  </div>
                </li>
                <li>
                  <div class="text_label">
                    <label>
                      <input
                        v-model="reasonsForDelete"
                        type="checkbox"
                        value="12"
                        class="check_agree"
                      />
                      <em></em>
                      <span>고객 응대 불만</span>
                    </label>
                  </div>
                </li>
                <li>
                  <div class="text_label">
                    <label>
                      <input
                        v-model="reasonsForDelete"
                        type="checkbox"
                        value="13"
                        class="check_agree"
                      />
                      <em></em>
                      <span>원하는 도서 없음</span>
                    </label>
                  </div>
                </li>
                <li>
                  <div class="text_label">
                    <label>
                      <input
                        v-model="reasonsForDelete"
                        type="checkbox"
                        value="14"
                        class="check_agree"
                      />
                      <em></em>
                      <span>전자책 로딩속도 불만</span>
                    </label>
                  </div>
                </li>
                <li>
                  <div class="text_label">
                    <label>
                      <input
                        v-model="reasonsForDelete"
                        type="checkbox"
                        value="15"
                        class="check_agree"
                      />
                      <em></em>
                      <span>기타</span>
                    </label>
                  </div>
                </li>
              </ul>
            </div>

            <div class="btn_wrap" data-detail="btn_bottom">
              <div class="text_label exception">
                <label>
                  <input
                    v-model="customerCheck"
                    type="checkbox"
                    class="check_agree"
                  />
                  <em></em>
                  <span>유의사항을 모두 확인했으며, 회원 탈퇴합니다.</span>
                </label>
              </div>
              <router-link :to="{ name: 'orders' }" class="box_btn dull">
                <span class="an_t">{{ $t('library.deletemodal.cancel') }}</span>
              </router-link>
              <button class="box_btn" @click="deleteAccount">
                <span class="an_t">{{
                  $t('views.member.closeaccount.7047')
                }}</span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- CONFIRM DELETE ACCOUNT MODAL -->
    <transition name="modal-fade">
      <Modal v-if="showDeleteModal" @close="toggleDeleteModal">
        <div class="ly_pop_content ly_pop_msg ly_txt">
          <div class="ly_pop_head">
            <a class="btn_ly_close svg_close"
              ><span>{{ $t('library.deletemodal.close') }}</span></a
            >
          </div>
          <div class="ly_inner">
            <p class="tac">
              {{ $t('views.member.closeaccount.2176') }}<br />{{
                $t('views.member.closeaccount.7647')
              }}
            </p>
            <div class="btn_wrap">
              <a href="#" @click="navigateToStore">
                <button class="box_btn">
                  <span class="an_t">{{ $t('library.deletemodal.ok') }}</span>
                </button>
              </a>
            </div>
          </div>
        </div>
      </Modal>
    </transition>
    <!-- ERROR MODAL -->
    <transition v-on-clickaway="toggleErrorModal" name="modal-fade">
      <Modal v-if="showErrorModal" @close="toggleErrorModal">
        <div class="ly_pop_wrap">
          <div class="ly_pop_content ly_pop_msg ly_txt">
            <div class="ly_pop_head">
              <a class="btn_ly_close svg_close" @click="toggleErrorModal"
                ><span>{{ $t('library.deletemodal.close') }}</span></a
              >
            </div>
            <div class="ly_inner">
              <p>
                {{ errorMessage }}
              </p>
              <div class="btn_wrap">
                <a href="#" @click="toggleErrorModal">
                  <button class="box_btn">
                    <span class="an_t">{{ $t('library.deletemodal.ok') }}</span>
                  </button>
                </a>
              </div>
            </div>
          </div>
        </div>
      </Modal>
    </transition>
  </div>
</template>

<script>
import { ACCOUNT_CLOSE, AUTH_LOGOUT } from '@/store/types'

/*
<코드 정보>
10	사용빈도 낮음
11	컨텐츠 다양성 불만
12	고객 응대 불만
13	원하는 도서 없음
14	전자책 로딩속도 불만
15	기타
*/

export default {
  name: 'CloseAccount',
  data() {
    return {
      showDeleteModal: false,
      showErrorModal: false,
      errorMessage: '',
      reasonsForDelete: [],
      customerCheck: false
    }
  },
  beforeRouteEnter(to, from, next) {
    // 이전 페이지가 edit_account가 아닌 경우 404로 리디렉션
    if (!from.name || from.name !== 'edit_account') {
      next({ name: '404' })
    } else {
      next((vm) => {
        vm.allowed = true // 페이지 접근을 허용
      })
    }
  },
  methods: {
    toggleDeleteModal() {
      this.showDeleteModal = !this.showDeleteModal
    },
    toggleErrorModal(errorMessage) {
      if (errorMessage) {
        this.errorMessage = errorMessage
      }
      this.showErrorModal = !this.showErrorModal
    },
    navigateToStore() {
      this.$store.dispatch(AUTH_LOGOUT)
      this.$store.reset()
      this.$router.push({ name: 'store' })
    },
    async deleteAccount() {
      if (!this.customerCheck) {
        alert('하단 동의버튼을 눌러주세요')
        return
      }
      try {
        await this.$store.dispatch(ACCOUNT_CLOSE, {
          profile: {
            withdrawalReason: this.reasonsForDelete
          }
        })
        this.toggleDeleteModal()
      } catch (err) {
        this.toggleErrorModal(
          `[${err.response.data.errorState.code}] ${err.response.data.errorState.message}`
        )
      }
    }
  }
}
</script>
<style src="@/assets/css/page_join.css" scoped></style>
<style src="@/assets/css/page_member.css" scoped></style>
<style lang="scss" scoped>
[data-detail*='se_detail'] {
  .done_tit {
    margin-top: 12px;
  }
  .add_tit {
    margin: 50px 0 13px 0;
  }
}
.done_tit {
  color: #000000;
  margin-bottom: 0;
  line-height: 30px;
}
.cart_st .box_wrap .box {
  width: auto;
}
.text_label {
  &.exception {
    input + em {
      width: 20px;
      height: 20px;
      background-size: 16px 10px;
      &::after {
        width: 20px;
        height: 20px;
        background-size: 16px 10px;
      }
    }
  }
  label {
    display: flex;
    align-items: center;
  }
}
.btn_wrap {
  label {
    margin-bottom: 5px;
  }
  span {
    user-select: none;
  }
}
[data-detail*='se_detail'] {
  .btn_wrap {
    margin-top: 10px;
  }
  .join_check > li {
    margin-bottom: 5px;
  }
}
@media (max-width: 1024px) {
  [data-detail*='se_detail'] {
    .add_tit {
      padding: 0 40px;
    }
    .join_check > li {
      margin-bottom: 10px;
    }
    .btn_wrap {
      margin-top: 0;
    }
  }
  .text_wrap {
    padding: 0 40px;
  }
  .btn_wrap {
    label {
      padding: 0 40px;
    }
  }
}
@media all and (max-width: 767px) {
  [data-detail*='se_detail'] .done_tit {
    line-height: 39px;
  }
  [data-detail*='se_detail'] .add_tit {
    padding-left: 10px;
  }
  .text_wrap {
    padding: 0 10px;
  }
  .btn_wrap {
    label {
      padding: 0 10px;
    }
  }
}
@media (max-width: 480px) {
  .cart_st .box_wrap {
    padding: 33px 0;
  }
  [data-detail*='se_detail'] {
    .done_tit {
      margin-top: 0px;
      font-size: 24px;
    }
    .add_tit {
      margin: 33px 0 15px 0;
      padding-left: 25px;
    }
    .btn_wrap {
      margin-top: 10px;
    }
  }
  .box_title {
    margin-bottom: 33px;
    p.guide_txt {
      margin-top: 5px;
    }
  }
  .text_wrap {
    padding: 0 25px;
  }
  .btn_wrap {
    label {
      padding: 0 25px;
    }
  }
  .cart_st .box_btn .an_t {
    line-height: 45px;
  }
  [data-detail*='btn_bottom'] .box_btn {
    width: 90px;
    height: 45px;
  }
}
</style>
